import React from "react";
import { makeHostHandler } from "@vived/vivedlearning_host";

export default React.createContext(undefined);

export function makeAppContext() {
    return {
        hostHandler: makeHostHandler()
    }
}